
import { useUserRole } from '@/hooks/useUserRole'
import AuthService from '@/services/Auth/AuthService'
import BookingSlotService from '@/services/BookingSlot/BookingSlotService'
import CompanyService from '@/services/Company/CompanyService'
import { BookingSlotType } from '@/types/BookingSlotType'
import { CompanyType } from '@/types/CompanyType'
import { flashStore } from '@/utils/Store'
import * as Sentry from '@sentry/react'
import { AxiosError, AxiosResponse } from 'axios'
import React from 'react'
import Swal, { SweetAlertResult } from 'sweetalert2'

interface ApiResponse {
  response: AxiosResponse
  data: string
}

export default function useBooking () {
    /* States / Hooks
       *******************************************************************************************/
      const [bookings, setData] = React.useState<CompanyType[]>([])
      const [loading, setLoading] = React.useState<boolean>(true)
      const [currentPage] = React.useState<number>(1)
      const [show, setShow] = React.useState<boolean>(false)
      const [bookingInput, setBookingInput] = React.useState<BookingSlotType>()
      const [onSubmitLoading, setOnSubmitLoading] = React.useState<boolean>(false)
      const flash = flashStore()
      const myRole = useUserRole()
    
      /* useEffect
       *******************************************************************************************/
      React.useEffect(() => {
        getData(currentPage)
      }, [currentPage])
    
      /* Functions
       *******************************************************************************************/
      const getData = (page: number) => {
        CompanyService.getBookingSlotsOfCompanies(page, 10)
          .then((response: AxiosResponse) => {
            setData(response.data['hydra:member'])
          })
          .catch((error: AxiosError) => {
            AuthService.refreshToken()
            Sentry.captureException(error)
          })
          .finally(() => {
            setLoading(false)
          })
      }
    
      const handleShowEditForm = (booking: BookingSlotType) => {
        setBookingInput(booking)
        setShow(true)
      }
    
      const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault()
        setOnSubmitLoading(true)
        // Récupérer les valeurs du formulaire
        const formData = new FormData(event.currentTarget)
        const id = formData.get('id') as string
        // const slot_available = Number(formData.get("slot_available"));
        const new_booking_capacity = Number(formData.get('capacity'))
        // const new_slot_available = slot_available - new_booking_capacity;
    
        const setDataBooking: BookingSlotType = {
          capacity: new_booking_capacity,
        }
    
        // const setDataSlot: SlotType = {
        //   available: new_slot_available,
        // };
    
        BookingSlotService.update(Number(id), setDataBooking)
          .then(() => {
            // updateSlot(Number(bookingInput?.slot?.id), setDataSlot);
            flash.setMessage('success', 'Booking #' + id + ' a bien été modifié')
          })
          .catch((error: AxiosError) => {
            flash.setMessageErrorForm()
            Sentry.captureException(error)
          })
          .finally(() => {
            setOnSubmitLoading(false)
            setShow(false)
            getData(currentPage)
          })
      }
    
      const handleDelete = (id: number) => {
        Swal.fire({
          title: 'Confirmation !',
          text: 'Voulez-vous vraiment supprimer le booking #' + id + ' ?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Oui, je confirme',
          cancelButtonText: 'Non',
        }).then((result: SweetAlertResult) => {
          if (result.isConfirmed) {
            deleteBooking(id)
          }
        })
      }
    
      const handleUpdateState = (id: number, state: boolean) => {
        const _data = { active: state }
    
        BookingSlotService.update(id, _data)
          .then(() => {
            if (state === false) {
              flash.setMessage('success', 'Booking #' + id + ' désactivé !')
            } else {
              flash.setMessage('success', 'Booking #' + id + ' activé !')
            }
          })
          .catch((e: ApiResponse) => {
            flash.setMessage('error', e?.response?.data['hydra:description'])
            getData(currentPage)
            Sentry.captureException(e)
          })
          .finally(() => {
            getData(currentPage)
          })
      }
    
      const deleteBooking = (id: number) => {
        const _data = { active: false }
    
        BookingSlotService.update(id, _data)
          .then(() => {
            BookingSlotService._delete(id)
              .then(() => {
                flash.setMessage('success', 'Booking supprimé !')
                getData(currentPage)
              })
              .catch((e: ApiResponse) => {
                flash.setMessage('error', e?.response?.data['hydra:description'])
                Sentry.captureException(e)
              })
          })
          .catch((e: ApiResponse) => {
            flash.setMessage('error', e?.response?.data['hydra:description'])
            Sentry.captureException(e)
          })
      }
    return {
        setShow,
      bookings,
      loading,
      currentPage,
      myRole,
      show,
      bookingInput,
      onSubmitLoading,
      handleShowEditForm,
      handleSubmit,
      handleDelete,
      handleUpdateState,
    }
} 